// Module
var code = "<el-row type=\"flex\" justify=\"center\"> <el-col :xs=\"24\" :sm=\"18\" :md=\"20\" :lg=\"12\"> <provider-form :item=\"item\" :form=\"'edit'\" :loading=\"loading_form\" v-loading=\"loading_page\" element-loading-spinner=\"fas fa-spinner fa-pulse fa-3x\" @changeProvider=\"changeProvider\"/> </el-col> </el-row> ";
// Exports
module.exports = code;